import React from 'react';
import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { createI18nT } from '../i18n.js';

export const installCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  const t = createI18nT();

  return createCommand('install')
    .description(t('site_install_command_def.description'))
    .argument('[package]', t('site_install_command_def.argument.package'))
    .action(async (packageName, _opts, command) => {
      const { renderCommand } = await import('./render-command.js');
      const { InstallCommand } = await import(
        '../components/InstallCommand/InstallCommand.js'
      );

      await renderCommand(
        command,
        services,
        cliVersion,
        <InstallCommand packageName={packageName} />
      );
    });
};
